import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import UIAssetKeys from '../UIAssetKeys';

export default class CounterText extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene,textTemplate, size, color) {
    super(scene);

    this.value = 0;
    this.textTemplate = textTemplate;
    this.size = size;
    this.color = color;

    const bg = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._puzzle_number, this).setOrigin(0);

    this.textLabel = ABCyaPhaser.Text.addText(15,32, `${size}pt`, color, FontKeys._asapbold, '', this, false).setOrigin(0);
    const result = this.textTemplate.replace('_VALUE_', `${this.value}`);
    this.textLabel.text = result;
  }

  setValue (value) {
    this.value = value;
    const result = this.textTemplate.replace('_VALUE_', `${value}`);
    this.textLabel.text = result;
  }
}